import {
	EnrollmentContextService,
	AnswerValueProp,
} from '../../context/enrollment/enrollment-context';
import moment from 'moment';
import { UseFormMethods } from 'react-hook-form';

export const unMaskValue = (
	value: string,
	mask: string[] | string,
	format: string
) => {
	let stringifiedmask = '';
	if (typeof mask === 'string') {
		stringifiedmask = mask;
	} else {
		stringifiedmask = mask.join('');
	}
	const charsToRemove =
		format
			.replaceAll('9', '')
			.replaceAll('a', '')
			.replaceAll('*', '')
			.replaceAll('_', '') + stringifiedmask;
	let unMaskedValue = value;
	if (unMaskedValue) {
		for (const char of charsToRemove) {
			unMaskedValue = unMaskedValue.replaceAll(char, '');
		}
	}
	return unMaskedValue;
};

export const updateValue = (
	enrollmentCtxt: EnrollmentContextService,
	name: string,
	value: Date | AnswerValueProp | undefined
) => {
	enrollmentCtxt.updateFormField({ answer: value, id: name });
};

export const resetField = (
	setValue: UseFormMethods['setValue'],
	name: string
) => {
	setValue(name, '', { shouldValidate: true });
};

export const formatDateInput = (value: string): string => {
	value = (value || '').trim();
	const ln = value.length;
	const dateMaxLength = 8;
	const yearLength = 4;
	if (ln < dateMaxLength) {
		return value;
	}
	// eslint-disable-next-line no-useless-escape
	const res = /(\d\d)\s*[\/\-]?\s*(\d\d)\s*[\/\-]?\s*(\d{2,})/.exec(value);
	if (!res || res.length < yearLength) {
		return value;
	}
	return `${res[3]}-${res[1]}-${res[2]}`; //NOSONAR
};

export const formatDate = (value: string) => {
	let formattedValue = value;
	const yearMaxLength = 4;
	const regex = /(\d{4,})-(\d{2})-(\d{2})/;
	const res = regex.exec(value);
	if (res != null && res.length === yearMaxLength) {
		formattedValue = `${res[2]}/${res[3]}/${res[1]}`; //NOSONAR
	}

	return formattedValue;
};

export const formatPhoneNumber = (value: string) => {
	let formattedValue = value;
	const phoneMaxLength = 10;
	if (value != null && value.length === phoneMaxLength) {
		formattedValue = `(${value.substring(0, 3)}) ${value.substring(//NOSONAR
			3, //NOSONAR
			6 //NOSONAR
		)}-${value.substring(6)}`; //NOSONAR
	}

	return formattedValue;
};

export const getAgeFromDOB = (dob: string) => {
	const birthDate = moment(dob + 'T00:00:00');
	const today = moment();
	today.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
	return today.diff(birthDate, 'years');
};

export const capitalize = (str: string): string => {
	str = String(str);
	return str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();
};
